function initArtistTheme() {
  const reveals = document.querySelectorAll("[data-artist-reveal]");

  if ("IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    reveals.forEach((item) => revealObserver.observe(item));
  } else {
    reveals.forEach((item) => item.classList.add("is-visible"));
  }

  const parallaxElements = document.querySelectorAll("[data-artist-parallax]");
  const applyParallax = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    parallaxElements.forEach((element) => {
      const rate = Number(element.getAttribute("data-artist-parallax")) || 0;
      element.style.transform = `translateY(${scrollY * rate / 100}px)`;
    });
  };

  if (parallaxElements.length) {
    applyParallax();
    window.addEventListener("scroll", applyParallax, { passive: true });
  }

  const portfolioSections = document.querySelectorAll("[data-artist-portfolio-section]");

  portfolioSections.forEach((section) => {
    const modal = section.querySelector("[data-artist-modal]");
    const modalImage = section.querySelector("[data-artist-modal-image]");
    const modalType = section.querySelector("[data-artist-modal-type]");
    const modalTitle = section.querySelector("[data-artist-modal-title]");
    const modalSubtitle = section.querySelector("[data-artist-modal-subtitle]");
    const modalMeta = section.querySelector("[data-artist-modal-meta]");
    const modalDescription = section.querySelector("[data-artist-modal-description]");
    const modalLink = section.querySelector("[data-artist-modal-link]");
    const modalClose = section.querySelector("[data-artist-modal-close]");
    const portfolioCards = section.querySelectorAll("[data-artist-portfolio-card]");

    let lastFocusedCard = null;

    const closeModal = () => {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (lastFocusedCard) {
        lastFocusedCard.focus();
      }
    };

    const openModal = (card) => {
      if (!modal) return;

      lastFocusedCard = card;
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      if (modalType) modalType.textContent = card.dataset.type || "";
      if (modalTitle) modalTitle.textContent = card.dataset.title || "";
      if (modalSubtitle) modalSubtitle.textContent = card.dataset.subtitle || "";
      if (modalMeta) modalMeta.textContent = card.dataset.meta || "";
      if (modalDescription) modalDescription.textContent = card.dataset.description || "";

      if (modalImage) {
        if (card.dataset.image) {
          modalImage.innerHTML = `<img src="${card.dataset.image}" alt="${card.dataset.imageAlt || card.dataset.title || ""}">`;
        } else {
          modalImage.innerHTML = `<div class="artist-placeholder"><span>Upload portfolio image</span></div>`;
        }
      }

      if (modalLink) {
        if (card.dataset.link) {
          modalLink.href = card.dataset.link;
          modalLink.hidden = false;
        } else {
          modalLink.hidden = true;
        }
      }

      if (modalClose) {
        modalClose.focus();
      }
    };

    portfolioCards.forEach((card) => {
      card.addEventListener("click", () => openModal(card));
      card.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openModal(card);
        }
      });
    });

    if (modal) {
      modal.addEventListener("click", (event) => {
        const target = event.target;
        if (target instanceof HTMLElement && target.hasAttribute("data-artist-modal-dismiss")) {
          closeModal();
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && modal.classList.contains("is-open")) {
          closeModal();
        }
      });
    }
  });
}

function initArtistAnalytics() {
  if (document.documentElement.dataset.artistAnalyticsReady === "true") return;
  document.documentElement.dataset.artistAnalyticsReady = "true";

  const track = (eventName, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...detail,
    });

    document.dispatchEvent(new CustomEvent(`artist:${eventName}`, { detail }));
  };

  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const addButton = target.closest("[data-product-submit], [data-product-card-interaction-addtocart]");
    if (addButton) {
      track("add_to_cart_click", {
        product_id: addButton.getAttribute("data-product-id") || "",
        variant_id: addButton.getAttribute("data-product-variant-id") || "",
        product_title: addButton.getAttribute("data-product-title") || "",
        source: addButton.hasAttribute("data-product-card-interaction-addtocart") ? "product_card" : "product_page",
      });
      return;
    }

    const checkoutButton = target.closest("[data-analytics-checkout]");
    if (checkoutButton) {
      track("begin_checkout_click", {
        source: checkoutButton.getAttribute("data-analytics-source") || "cart",
        cart_total: checkoutButton.getAttribute("data-cart-total") || "",
        cart_item_count: checkoutButton.getAttribute("data-cart-item-count") || "",
      });
      return;
    }

    const removeLink = target.closest("[data-cart-action='remove']");
    if (removeLink) {
      track("remove_from_cart_click", {
        variant_id: removeLink.getAttribute("data-product-variant-id") || "",
        product_title: removeLink.getAttribute("data-product-title") || "",
      });
      return;
    }

    const portfolioCard = target.closest(".pex-card");
    if (portfolioCard) {
      track("portfolio_open", {
        title: portfolioCard.getAttribute("data-analytics-title") || "",
        type: portfolioCard.getAttribute("data-type") || "",
      });
    }
  });

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches("[data-cart-item-quantity]")) return;

    track("cart_quantity_change", {
      quantity: target.value,
      variant_id: target.getAttribute("data-product-variant-id") || "",
      product_title: target.getAttribute("data-product-title") || "",
    });
  });
}

document.addEventListener("DOMContentLoaded", initArtistTheme);
document.addEventListener("DOMContentLoaded", initArtistAnalytics);
document.addEventListener("shopify:section:load", initArtistTheme);
